/* global _ */
module.exports = ['$scope', '$stateParams', 'curriculumManager', '$state', 'ngMeta',
  function ($scope, $stateParams, curriculumManager, $state, ngMeta) {
    'use strict';

    function loadTheme(themeKey) {
      curriculumManager.getThemeByIdentifiers($stateParams.fieldKey, themeKey).then(function (theme) {
        if (typeof theme === 'undefined') {
          $state.go('notFound', {}, { location: false });
        }
        $scope.theme = theme;
        ngMeta.setTitle(theme.title);
        ngMeta.setTag('description', theme.description);
        ngMeta.setTag('image', theme.coverUrl);

        $scope.goNextTheme = function () {
          curriculumManager.getNext(theme).then(function (nextTheme) {
            loadTheme(nextTheme.identifiers[0]);
            $state.go('leerinhoud.theme', {themeKey: nextTheme.identifiers[0]}, { notify: false, location: 'replace' });
          });
        };

        $scope.goPrevTheme = function () {
          curriculumManager.getPrev(theme).then(function (prevTheme) {
            loadTheme(prevTheme.identifiers[0]);
            $state.go('leerinhoud.theme', {themeKey: prevTheme.identifiers[0]}, { notify: false, location: 'replace' });
          });
        };

      });
    }

    curriculumManager.getFieldById($stateParams.fieldKey).then(function (field) {
      $scope.field = field;
      loadTheme($stateParams.themeKey);
    });
  }
];



// WEBPACK FOOTER //
// ./web/js/screen/leerinhoud/theme/leerinhoudThemeController.js